export default {
    alerts: []
}